import { useTranslation } from '../lib/i18n/TranslationContext';
import Boss from '../ui/appsIcons/Boss';
import { Button } from '../ui/Button';

const Footer = ({ suportLink }: { suportLink: string }) => {
	const { t } = useTranslation();

	return (
		<div className='w-full max-w-[1024px] pt-6 px-6 border-t border-gray-200 flex flex-row items-center gap-2 mb-6'>
			<Boss />
			<p className='text-gray-900 font-inter text-sm not-italic font-normal leading-5'>Padrão <a href='https://empreender.plus/' target='_blank'>Empreender</a> {t('de Excelência - 2009. Todos os direitos reservados.')}</p>
			<Button asChild variant='outline' className='border-gray-200 text-gray-900'>
				<a href={suportLink} target='_blank'>
					{t('Reportar problema')}
				</a>
			</Button>
		</div>
	);
};

export default Footer;
